var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 122C94.6894 122 122 94.6894 122 61C122 27.3106 94.6894 0 61 0C27.3106 0 0 27.3106 0 61C0 94.6894 27.3106 122 61 122Z",
    fill: "#FDEEEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2894_2166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 122
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 122C94.6894 122 122 94.6894 122 61C122 27.3106 94.6894 0 61 0C27.3106 0 0 27.3106 0 61C0 94.6894 27.3106 122 61 122Z",
    fill: "#FDEEEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2894_2166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.96 46.3599H100.04",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.96 75.6401H100.04",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.96 61H100.04",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3601 126.88L46.3601 21.9599",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6399 126.88V21.9599",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 126.88L61 21.9599",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.3999,
    y: 86.3999,
    width: 50.8,
    height: 50.8,
    rx: 3,
    transform: "rotate(-180 86.3999 86.3999)",
    fill: "white",
    stroke: "#060B1F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7669 66.371H52.6497L50.8952 71.3229H46.3601L54.7021 48.7998H58.0455L66.3875 71.3229H61.6207L59.7669 66.371ZM53.8083 62.8568H58.7738L57.0524 57.8729L56.3573 54.3587H56.1917L55.4966 57.9049L53.8083 62.8568Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.665 48.9595H73.2001V71.3229H68.665V48.9595Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.6799,
    y: 79.52,
    width: 16.64,
    height: 16.64,
    rx: 8.32,
    fill: "#A3A3A3",
    stroke: "#060B1F",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.e87c0c99000bc86a866aa061bd3c18d8.svg";
export { ForwardRef as ReactComponent };